import React, { useState, useEffect, useCallback } from 'react';
import ShootingStar from './ShootingStar';

let starIdCounter = 0; // Simple ID generator

const StarManager = () => {
  const [stars, setStars] = useState([]);

  const addStar = useCallback(() => {
    const newId = starIdCounter++;
    // Limit number of stars on screen if needed, e.g., if (stars.length < MAX_STARS)
    setStars(prevStars => [...prevStars, { id: newId }]);
  }, []);

  const removeStar = useCallback((idToRemove) => {
    setStars(prevStars => prevStars.filter(star => star.id !== idToRemove));
  }, []);

  useEffect(() => {
    // Function to schedule the next star
    let timeoutId;
    const scheduleNextStar = () => {
      const delay = Math.random() * 5000 + 5000; // 5 to 10 seconds
      timeoutId = setTimeout(() => {
        addStar();
        scheduleNextStar(); // Schedule the next one
      }, delay);
    };

    scheduleNextStar(); // Start the cycle

    return () => clearTimeout(timeoutId); // Cleanup on unmount
  }, [addStar]);

  return (
    // This container is just to hold the stars, it doesn't need visual styling itself
    // Positioned fixed to cover viewport, pointer-events none so it doesn't block interaction
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', pointerEvents: 'none', zIndex:0 }}>
      {stars.map(starInfo => (
        <ShootingStar
          key={starInfo.id}
          id={starInfo.id}
          onComplete={removeStar}
        />
      ))}
    </div>
  );
};

export default StarManager;